import React, { useState } from 'react';
import { collection, getDocs, query, where, doc, getDoc } from 'firebase/firestore';
import { app, db } from '../firebase';
import StyledTable from './StyledTable';
import './FetchPatientHistory.css'; // same CSS as used in AppointmentList.js
import { useTenant } from '../context/TenantContext';

function FetchPatientHistory() {
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState([]);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [appointments, setAppointments] = useState([]);
  const [selectedPrescription, setSelectedPrescription] = useState(null);
  const [prescriptionModalOpen, setPrescriptionModalOpen] = useState(false);
  const { tenantId, loading } = useTenant()

  const handleSearch = async () => {
    const term = searchTerm.trim().toLowerCase();
    setResults([]);
    setSelectedPatient(null);
    setAppointments([]);

    if (!term) return;

    try {
      const q = query(collection(db, 'patients'), where('tenantId', '==', tenantId));
      const snapshot = await getDocs(q);
      const allPatients = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      const filtered = allPatients.filter(patient => {
        const name = patient.name?.toLowerCase() || '';
        const phone = typeof patient.phone === 'string' ? patient.phone : '';
        return name.includes(term) || phone.includes(term);
      });
      setResults(filtered);
    } catch (error) {
      console.error('Error fetching patients:', error);
    }
  };

  const viewPrescription = async (prescriptionId) => {
  try {
    const docRef = doc(db, 'prescriptions', prescriptionId);
    const snap = await getDoc(docRef);
    if (snap.exists()) {
      setSelectedPrescription(snap.data());
      setPrescriptionModalOpen(true);
    } else {
      alert("Prescription not found.");
    }
  } catch (err) {
    console.error("Failed to fetch prescription:", err);
    alert("Error fetching prescription.");
  }
};


  const handleSelectPatient = async (patient) => {
    setSelectedPatient(patient);
    setResults([]);

    try {
      const q = query(collection(db, 'appointments'), where('patientId', '==', patient.id));
      const snap = await getDocs(q);

      const appointmentsWithDoctor = await Promise.all(
        snap.docs.map(async (docSnap) => {
          const data = docSnap.data();
          
          const doctorDoc = await getDoc(doc(db, 'doctors', data.doctorId));
          const patientDoc = await getDoc(doc(db, 'patients', data.patientId));
          const appointmentDoc = await getDoc(doc(db, 'appointments', docSnap.id));
          return {
            datetime: data.datetime?.toDate()?.toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
              hour: '2-digit',
              minute: '2-digit'
            }) || '',
            patientName: patientDoc.exists() ? patientDoc.data().name : 'Unknown',
            patientPhone: patientDoc.exists() ? patientDoc.data().phone : 'Unknown',
            doctorName: doctorDoc.exists() ? doctorDoc.data().name : 'Unknown',
            prescriptionId: appointmentDoc.exists() ? appointmentDoc.data().prescriptionId : null,
          };
        })
      );

      setAppointments(appointmentsWithDoctor);
    } catch (error) {
      console.error('Error fetching appointments:', error);
    }
  };


  return (
    <div className="fetch-history-container">
      <h2>Fetch Patient History</h2>
      <div className='search-section'>
      <input
        type="text"
        placeholder="Search by name or phone"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <button onClick={handleSearch}>Search</button>
      </div>

      {results.length > 0 && (
        <ul className="results-list">
          {results.map((patient) => (
            <li key={patient.id} onClick={() => handleSelectPatient(patient)}>
              {patient.name} - {patient.phone}
            </li>
          ))}
        </ul>
      )}

      {selectedPatient && (
    
        <>
          <h3 className='apptheader'>Appointment History for {selectedPatient.name} - {selectedPatient.phone}</h3>
          <StyledTable
            headers={['Date & Time', 'Doctor', 'View Prescription']}
            data={appointments}
            renderRow={(appt) => (
        <>
            <div>{appt.datetime}</div>
            <div>{appt.doctorName}</div>
            <div>
                {appt.prescriptionId ? (
                <button onClick={() => viewPrescription(appt.prescriptionId)}>View Prescription</button>
                ) : (
                <span style={{ color: 'gray' }}>No Prescription</span>
                )}
            </div>

        </>
      )}
    />

            {prescriptionModalOpen && selectedPrescription && (
  <div className="modal-overlay">
    <div className="modal-content">
      <h3>Prescription</h3>
      {selectedPrescription.slipUrl ? (
        <>
          <img
            src={selectedPrescription.slipUrl}
            alt="Prescription Slip"
            className="prescription-image"
          />
          <div style={{ marginTop: '10px' }}>
            <button
              className="presprevbtn"
              onClick={() => window.open(selectedPrescription.slipUrl, "_blank")}
            >
              Open
            </button>
          </div>
        </>
      ) : (
        <p>No slip uploaded.</p>
      )}
      <button className='presprevbtn' onClick={() => setPrescriptionModalOpen(false)}>Close</button>
    </div>
  </div>
)}



    </>
    )}
    </div>
  );
}

export default FetchPatientHistory;
